import { Component, OnInit } from '@angular/core';
import { LoanGtmService } from 'projects/apna-lib/src/lib/services/loan-gtm.service';
import { UploadDocumentData } from './upload-document-components/upload-form/upload-form.component';
import { ConfigService } from 'projects/apna-lib/src/lib/services/config.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiHelperService } from 'projects/apna-lib/src/lib/services/api-helper.service';
import { CardInterface, ConfigInterface, StepperInterface, WebConfigInterface } from 'projects/apna-lib/src/lib/interfaces/common-interface';
import { UserIdentityService } from 'projects/apna-lib/src/lib/services/user-identity.service';

@Component({
  selector: 'fa-upload-document',
  templateUrl: './upload-document.component.html',
  styleUrls: ['./upload-document.component.scss']
})
export class UploadDocumentComponent implements OnInit {
  showBulkUpload: boolean = false;
  isPartnerLink: boolean = false;
  active = 1;
  uploadFormData: UploadDocumentData;
  catergoryOptions: any[] = this.configService.getConfig1("foreignAdmits", "documentCategoryOptions");
  documentOptionsList: any[] = this.configService.getConfig1("foreignAdmits", "documentOptionsList");
  loanWidgetConfig: any = this.configService.getConfig1("loanWidgetConfig");
  documentOptionsListCopy: any[];
  partnerLogo: string;
  uploadedDocuments: number = 0;
  studentDetails: any;
  dataModel: string = "user-documents";
  otherDocumentData: any;
  canLogout: boolean = true;
  step: string = "showDefaultLayout";
  stepWeb: string = "showSingleUpload";
  defaultStep: string = "showDefaultStep";
  config: ConfigInterface = this.loanWidgetConfig?.uploadDocHeaderConfig;
  cardConfig: CardInterface = this.loanWidgetConfig?.uploadDocCardCarouselConfig;
  steps: StepperInterface = this.loanWidgetConfig?.uploadDocStepperConfig;
  webData: WebConfigInterface = this.loanWidgetConfig?.uploadDocWebHeaderConfig
  webConfig: WebConfigInterface = this.loanWidgetConfig?.uploadDocWebHeaderConfig
  userData: any;
  selectedCategory: string;
  constructor(
    public loanService: LoanGtmService,
    private configService: ConfigService,
    private route: Router,
    private activatedRoute: ActivatedRoute,
    private apiHelper: ApiHelperService,
  ) { }

  ngOnInit(): void {
    const puid = this.activatedRoute.snapshot.paramMap.get('puid');
    if (puid) {

      localStorage.setItem('puid', puid);
      if (puid && (puid == 'LGQUJ0E2' || puid == 'LFI75BEH') && !this.loanService.isPrefilledDataOnBack) {
        this.apiHelper.getDataById(this.dataModel, this.loanService?.studentDetails?.id).subscribe((data: any) => {
          this.getPartnerDetails(puid);
          this.isPartnerLink = true;
          if (data?.otherDocuments || data?.uploadType === "bulkUpload") {
            this.stepWeb = "showBulkUpload"
          }
          else {
            this.stepWeb = "showSingleUpload"
          }

        })
      }
      else {
        this.isPartnerLink = true;
        if (!this.loanService?.partnerDetails) {
          this.getPartnerDetails(puid);
        }
        else {
          this.webData = {
            ...this.webData,
            isPartnerLogo: true,
            logo: this.loanService.partnerDetails?.company?.showCompanyLogo ? this.loanService?.partnerDetails?.company?.logo : undefined
          }
          this.partnerLogo = this.loanService.partnerDetails?.company?.showCompanyLogo ? this.loanService?.partnerDetails?.company?.logo : undefined;
          this.checkUserLoggedIn(puid);
        }
      }

    }
    this.setHeader(puid);
    this.checkUserLoggedIn(puid);
    this.setDocumentOptions('academicDocuments');
    this.dataPreprocessor();
    this.selectedCategory = 'academicDocuments';
    this.studentDetails = { ...this.loanService.studentDetails };

  }
  dataPreprocessor() {
    this.loanService.getLoanApplication(this.loanService?.studentDetails?.id).then((data: any) => {
      this.loanService.loanDetails = Object.assign(this.loanService.loanDetails, { ...data[0] })
      this.webData = {
        ...this.webData,
        loan: {
          loanType: this.loanService?.loanDetails?.loanType,
          loanAmount: this.loanService?.loanDetails?.loanAmount,
          loanAmountCurrency: this.loanService?.loanDetails?.loanAmountCurrency
        }
      }
    })
  }

  setHeader(puid: any) {
    if (!puid) {
      this.config = {
        title: "Upload Documents",
        logout: `/`,
        backLink: `/application-status`,
        showHeaderShadow: true,
        showMobileView: true,

      }
      this.webConfig = {
        title: "Upload Documents",
        backLink: `/application-status`
      }

      this.webData = {
        backLink: `/application-status`,
        logout: '/',
        logo: this.webData?.logo,
        ...this.webData,
        loan: {
          loanType: this.loanService?.loanDetails?.loanType,
          loanAmount: this.loanService?.loanDetails?.loanAmount,
          loanAmountCurrency: this.loanService?.loanDetails?.loanAmountCurrency
        }
      }
    }
    else {
      this.config = {
        title: "Upload Documents",
        logout: '/' + puid,
        backLink: `/application-status/${puid}`,
        showHeaderShadow: true,
        showMobileView: true,
      }
      this.webConfig = {
        title: "Upload Documents",
        backLink: `/application-status/${puid}`,

      }
      this.webData = {
        backLink: `/application-status/${puid}`,
        logout: `/${puid}`,
        ...this.webData,
        loan: {
          loanType: this.loanService?.loanDetails?.loanType,
          loanAmount: this.loanService?.loanDetails?.loanAmount,
          loanAmountCurrency: this.loanService?.loanDetails?.loanAmountCurrency
        }
      }
    }
    const docsCount = Number(sessionStorage.getItem("documentCount"))
    if (docsCount >= 23) {
      this.steps.steps[1].status = "completed"
    }
  }
  updateDocumentUpload(count: number) {
    this.uploadedDocuments = count;
  }

  toggleBulk(ev: any) {
    ev.stopPropagation();
    this.stepWeb = "showBulkUpload";
    this.webConfig.title = "Upload in Bulk";
    this.webConfig.stepEmitter = "showSingleUpload";
    this.webConfig.backLink = undefined;
  }

  getPartnerDetails(partnerUid: string) {
    this.apiHelper.getDataById("users/partner", partnerUid)?.subscribe({
      next: (response: any) => {
        // Handle successful response
        let partnerDetails = { ...response };
        localStorage.setItem('puid', partnerUid);
        this.loanService.studentDetails.parentId = partnerDetails?.id;
        this.loanService.studentDetails.puid = partnerDetails?.uid;
        this.loanService.partnerDetails = { ...partnerDetails };
        this.webData = {
          ...this.webData,
          isPartnerLogo: true,
          logo: this.loanService.partnerDetails?.company?.showCompanyLogo ? this.loanService?.partnerDetails?.company?.logo : undefined
        }
      },
      error: (error: any) => {
        this.route.navigate(['/upload-documents'])
        this.isPartnerLink = false;
      }
    });
  }

  checkUserLoggedIn(puid: any) {
    if (this.activatedRoute.snapshot.queryParams?.hasOwnProperty("referenceId") && this.activatedRoute?.snapshot.queryParams.hasOwnProperty("token")) {
      const referenceId = this.activatedRoute.snapshot.queryParams.referenceId;
      const token = this.activatedRoute.snapshot.queryParams.token
      this.loanService.getStudentDetailsById(referenceId).then((data: any) => {
        const userDetails = { ...data[0] }
        this.loanService.saveStudentDetails(data[0]);
        localStorage.setItem("userDetails", JSON.stringify(userDetails));
        localStorage.setItem("token", token);
        localStorage.setItem("userId", referenceId);
        localStorage.setItem("ttl", "3600")
        this.canLogout = false
        this.webConfig.stepEmitter = "showSingleUpload"
        this.webConfig.backLink = undefined;
        this.config["logout"] = undefined;
        this.config["backLink"] = undefined;
        this.webData["logout"] = undefined;
        this.webConfig["backLink"] = undefined;
      })
    }
    else if (!this.loanService?.studentDetails.hasOwnProperty("id") || !this.loanService?.studentDetails?.id) {
      if (this.isPartnerLink) {
        this.route.navigate(['/' + puid], { queryParams: { uploadDocuments: true } });
        return;
      }
      this.route.navigate(['/'], { queryParams: { uploadDocuments: true } })
    }

  }

  back() {
    if (this.isPartnerLink) {
      this.route.navigate(['/application-status/' + this.loanService?.partnerDetails?.uid]);
      return;
    }
    this.route.navigate(['/application-status'])
  }

  changeCategory(category: string) {
    this.step = "showDocsLayout";
    this.uploadFormData = undefined;
    this.selectedCategory = category;
    setTimeout(() => {
      this.setDocumentOptions(category);

      if (this.uploadFormData.model && this.uploadFormData.model?.hasOwnProperty('category')) {
        this.uploadFormData.model.category = category;
      }
    }, 100)

  }
  changeCategoryMobile(category: string, title: string) {
    this.step = "showDocsLayout"
    this.config.title = title
    this.config.stepEmitter = "showDefaultLayout"
    this.setDocumentOptions(category);
    if (this.uploadFormData.model && this.uploadFormData.model?.hasOwnProperty('category')) {
      this.uploadFormData.model.category = category;
    }
  }


  setDocumentOptions(category: string) {
    this.documentOptionsListCopy = this.documentOptionsList.filter((single) => single?.category?.includes(category));
    if (this.uploadFormData?.model) {
      this.uploadFormData = Object.assign(this.uploadFormData, { documentOptions: [...this.documentOptionsListCopy] });
    }
    else {
      this.uploadFormData = {
        model: {
          category: "academicDocuments"
        },
        documentOptions: [...this.documentOptionsListCopy]
      };
    }
  }

  logout() {
    if (this.isPartnerLink) {
      this.route.navigate(['/' + this.loanService?.partnerDetails?.uid]);
      return;
    }
    this.route.navigate(['/'])
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.setScrollPosition();
    }, 2000)

  }

  setScrollPosition() {
    if (typeof window === "object") {
      let x = document.getElementById("cardWrapper");
      x?.scroll({ top: 0, left: 90, behavior: "smooth" })
    }
  }
  emitStep(ev: any) {
    if (window?.innerWidth < 1200) {
      this.step = ev;
      this.config.title = "Upload Documents";
      this.config.stepEmitter = undefined;
      if (this.isPartnerLink) {
        this.config.backLink = `/application-status/${this.loanService?.partnerDetails?.uid}`;
        return;
      }
      else {
        this.config.backLink = "/application-status";
      }
    }
    else {
      this.stepWeb = ev;
      this.webConfig.title = "Upload Documents";
      this.webConfig.stepEmitter = undefined;
      if (!this.canLogout) {
        this.webConfig.backLink = undefined;
        return;
      }
      if (this.isPartnerLink) {
        this.webConfig.backLink = `/application-status/${this.loanService?.partnerDetails?.uid}`;
        return;
      }
      else {
        this.webConfig.backLink = "/application-status"
      }
    }

  }

  emitEventBulk(event: any) {
    this.defaultStep = event;
  }
}
